export default __webpack_public_path__ + "static/media/Table-House-Pricing.a6519b36.svg";